import React from "react";
// import clsx from "clsx";
// import { useFormChangeHandler } from "hooks/useFormChangeHandler";
// import { useSubmitHandler } from "hooks/useSubmitHandler";
// import { useCreateData, useUpdateData } from "hooks/useApiHooks";
// import Select from "react-select";
// import makeAnimated from "react-select/animated";
// import CreatableSelect from "react-select/creatable";
// import { getRequest } from "services/api";
// import { buildQueryString } from "utils/queryHelpers";
import MasterDataFormV2 from "pages/POS/MasterDataFormV2";

// const animatedComponents = makeAnimated();

const TierForm = ({ initialData, onSuccess, onError }) => {
  return (
    <MasterDataFormV2
      title="Tier"
      apiUrl="/tier"
      initialData={initialData}
      fields={[
        {
          name: "name",
          label: "Tier Name",
          type: "text",
          required: true,
          maxLength: 255,
        },

        {
          name: "image",
          label: "Image URL",
          type: "file",
          placeholder: "https://example.com/image.jpg",
        },
        {
          name: "start",
          label: "Min Bookings",
          type: "number",
          required: true,
          min: 0,
        },
        {
          name: "end",
          label: "Max Bookings",
          type: "number",
          required: true,
          min: 0,
        },
        {
          name: "color",
          label: "Color",
          type: "color",
          // maxLength: 7,
          // placeholder: "#000000",
        },
        // { name: "image", label: "Foto", type: "file" },
      ]}
      onSuccess={onSuccess}
      onError={onError}
    />
  );
};

export default TierForm;
